<div  [ngClass]="data?.theme == 'dark' ? 'dark-mode' : ''">
<mat-dialog-content [ngClass]="data?.theme == 'dark' ? 'dark-bg' : 'p-4'">
    <div class="d-flex justify-content-between">
        <h3 style="font-size: 22px;" [ngClass]="data?.theme == 'dark' ? 'text-white' : ''">Confirmation</h3>
        <button mat-icon-button (click)="closeDialog()" [ngClass]="data?.theme == 'dark' ? 'text-white' : ''">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="mt-3" *ngIf="data?.message && data?.message != ''">
        <b [ngClass]="data?.theme == 'dark' ? 'text-grey' : ''">{{data?.message}}</b>
    </div>
    <div [ngClass]="data?.theme == 'dark' ? 'text-grey' : ''">{{data?.subMessage}}</div>
</mat-dialog-content>
</div>
<div  [ngClass]="data?.theme == 'dark' ? 'dark-mode' : ''">
<mat-dialog-actions [ngClass]="data?.theme == 'dark' ? 'dark-bg p-4 justify-content-end' : 'p-4 justify-content-end'">
    <button mat-raised-button (click)="closeDialog()">{{ data?.buttonCancelLabel }}</button>
    <button mat-raised-button (click)="ok()"
            [ngStyle]="data?.theme === 'dark' ? {'background': '#FFB400', 'color': '#000'} : {'background': '#5B25B4', 'color': '#fff'}">
    {{data?.buttonOkLabel}}</button>
</mat-dialog-actions>
</div>
